import { Component, ChangeDetectionStrategy, ElementRef, ViewChild, inject } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs';

// Browser messages for a lazy-loaded chunk that can't be fetched (Chrome/Edge, Firefox, Safari)
const CHUNK_LOAD_FAILED = /dynamically imported module|Importing a module script failed|ChunkLoadError/i;

/**
 * Each deploy replaces the hashed page chunks. A tab still running the previous version then fails to open the next page.
 * Members may only have come here from a payment link, so instead of an error they get a full-screen explanation whose only
 * action is to reload straight to the page they were going to. Plain markup (no NgbModal) to keep the initial bundle small.
 */
@Component({
  selector: 'app-new-version-notice',
  templateUrl: './new-version-notice.component.html',
  styleUrls: ['./new-version-notice.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NewVersionNoticeComponent {
  private router = inject(Router);

  targetUrl: string | null = null;

  @ViewChild('reloadButton') set reloadButton(button: ElementRef<HTMLButtonElement> | undefined) {
    button?.nativeElement.focus();
  }

  constructor() {
    // The shell lives as long as the app, so this subscription never needs to end
    this.router.events.pipe(filter((event): event is NavigationError => event instanceof NavigationError)).subscribe(event => {
      const message = event.error instanceof Error ? event.error.message : String(event.error);
      if (this.targetUrl === null && CHUNK_LOAD_FAILED.test(message)) this.targetUrl = event.url;
    });
  }

  reload() {
    window.location.href = this.targetUrl ?? window.location.href;
  }
}
